import { Injectable, signal } from '@angular/core';
import { Platform } from '@ionic/angular';
import { fromEvent } from 'rxjs';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { PlatformService } from '../platform/platform.service';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  public hasInternetAccess = signal<boolean>(true);
  public isCordova: boolean = this.platformService.isCordova();
  private online$;
  private offline$;

  constructor(
    private network: Network,
    private platform: Platform,
    private platformService: PlatformService
  ) {
    this.platform.ready().then(() => {
      if (this.isCordova) {
        // Cordova: Listen to network events
        this.hasInternetAccess.set(this.network.type !== 'none');
        this.network.onConnect().subscribe(() => this.hasInternetAccess.set(true));
        this.network.onDisconnect().subscribe(() => this.hasInternetAccess.set(false));
      } else {
        // Web: Listen to browser online/offline events
        this.hasInternetAccess.set(navigator.onLine);
        fromEvent(window, 'online').subscribe(() => this.hasInternetAccess.set(true));
        fromEvent(window, 'offline').subscribe(() => this.hasInternetAccess.set(false));
      }
    });
  }
}